<template>
  <div id="app">
    <preisanfrage-formular />
  </div>
</template>

<script>
import PreisanfrageFormular from './components/PreisanfrageFormular.vue'

export default {
  components: { PreisanfrageFormular },
  name: 'App',
}
</script>

<style>
* { 
  font-family: 'Noto Sans', sans-serif;
  } 
body {
  padding: 0;
  margin: 0;
  }
</style>